<template>
    <div>
        <li class="m_li" id="minarg" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <a href="javascript:;">
                <em class="f"><i class="iconfont icon-gouwuchekong" style="color:#ffffff;font-size:22px;"></i></em>
                <i id="carr_num">{{number}}</i>
            </a>
            <p class="rt_line"></p>
            <div class="r_av m_tr" id="racar" :style="active">
                <em class="r_vt">◆</em>
                <div class="ac_t alR" style="z-index:9999;" v-if="number != ''">
                    <ul class="acar">
                        <li v-for="(item,index) in list.slice(0,3)" :key="index">
                            <router-link :to="{path:'/detail', query:{id:item.pro.id}}"  target="_blank">
                                <img :src="item.pro.piclink" width="60" height="60" class="left">
                                <p>{{item.pro.title}}</p>
                                <p class="mt5">¥{{$fnc.toFixedZ(item.pro.price)}} x {{item.number}}</p>
                            </router-link>
                        </li>
                    </ul>
                    <div class="ac_t">
                        <a href="javascript:;" @click="buycar" class="srbtn mt5">
                            <b class="f"></b>
                            去购物车结算
                         </a>
                    </div>
                </div>
                <div class="ac_t alR" style="z-index:9999;" v-else>
                    您的购物车是空的,赶紧选购吧！
                </div>
            </div>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
            list:"",
            number:"",
        }
    },
    mounted() {
        this.cartList();
        /*页面挂载获取保存的localStorage值，渲染到页面上*/
        if(window.localStorage.getItem("user")){
            this.name = JSON.parse(window.localStorage.getItem("user")).username
        }
		
    },
    methods:{
        buycar(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/car')
			}else{
				this.$router.push('/login')
			}
		},
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li";
            this.active="opacity: 0; right: 70px; display: none;"
        },
        //购物车
		cartList(){
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getShop.getCartList(cart_params).then(res => {
                if (res.code == 200) {
                    this.list = [];
                    // console.log(this.list)
                    // this.number = res.result[0].data.length;
                    if(res.result[0].all_price == ""){
                        this.number = 0;
                    }else{
                        this.number = res.result[0].data.length;
                        var arr = res.result[0].data;
                        // console.log(arr)
                        arr.forEach((item,i) => {
                            this.list.push(item);
                        });
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.active{display: none;}
</style>



// WEBPACK FOOTER //
// src/components/common/right-car.vue